(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-aspect-banner"] && !Shopify.designMode) return;
  try {
    const applyCollectionBannerLinks = () => {
  const mobile = window.matchMedia('(max-width: 767px)').matches;
  document.querySelectorAll('.collection-banner-link[data-mobile-href]').forEach((link) => {
    if (!link.dataset.desktopHref) link.dataset.desktopHref = link.getAttribute('href');
    link.setAttribute('href', mobile ? link.dataset.mobileHref : link.dataset.desktopHref);
  });
};

applyCollectionBannerLinks();
window.addEventListener('resize', applyCollectionBannerLinks);
  } catch(e) { console.error(e); }
})();

})();
